var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticStyle:{"background-color":"#FAFAFA"},attrs:{"flat":""}},[_c('v-toolbar-title',[_c('h2',[_vm._v("Reporting")])]),_c('v-spacer'),_c('app-timeselector',{on:{"datesUpdate":_vm.datesUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }